// react
import { useContext, useMemo } from 'react';

// router
import { useSearchParams } from 'react-router-dom';

// types
import { Invoice } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextInvoices } from '../Contract.context';

// mui
import { Alert, Grid, Skeleton, Typography } from '@mui/material';

// cards
import { CardInvoice } from '../../../cards/CardInvoice/CardInvoice';

// dialogs
import { DialogEditInvoice } from '../../../dialogs/DialogEditInvoice/DialogEditInvoice';

export const Invoices = () => {
	// hooks
	const { t } = useTranslation();
	const [searchParams, setSearchParams] = useSearchParams();
	const { invoices, isLoadingInvoices, refetchInvoices } = useContext(ContextInvoices);

	// memos
	const invoiceSelected = useMemo(() => {
		const invoiceId = searchParams.get('invoice');

		if (!invoiceId) {
			return null;
		}

		return invoices.find((invoice) => String(invoice.id) === invoiceId) ?? null;
	}, [invoices, searchParams]);

	const isOpenDialogEditInvoice = invoiceSelected != null;

	const handleCloseDialog = () => {
		const params = new URLSearchParams(searchParams);
		params.delete('invoice');
		setSearchParams(params);
	};

	const handleInvoiceClick = (invoiceClicked: Invoice) => {
		const params = new URLSearchParams(searchParams);
		params.set('invoice', String(invoiceClicked.id));
		setSearchParams(params);
	};

	let content = null;

	if (isLoadingInvoices) {
		content = (
			<Grid item xs={12}>
				<Grid container spacing={2}>
					{[...Array(3)].map((a, i) => {
						return (
							<Grid item key={`skeleton-${i}`} xs={12}>
								<Skeleton height={140} variant="rounded" />
							</Grid>
						);
					})}
				</Grid>
			</Grid>
		);
	} else {
		if (invoices.length) {
			content = invoices.map((invoice) => {
				return (
					<Grid item key={`invoice-${invoice.id}`} xs={12}>
						<CardInvoice invoice={invoice} onClick={handleInvoiceClick} />
					</Grid>
				);
			});
		} else {
			content = (
				<Grid item xs={12}>
					<Alert severity="info" variant="filled">
						{t('alert.empty')}
					</Alert>
				</Grid>
			);
		}
	}

	return (
		<>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography color="common.white" variant="h3">
						{t('invoices')}
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<Grid container spacing={2}>
						{content}
					</Grid>
				</Grid>
			</Grid>
			<DialogEditInvoice
				invoice={invoiceSelected}
				isOpen={isOpenDialogEditInvoice}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchInvoices();
					handleCloseDialog();
				}}
			/>
		</>
	);
};
